/**
 * Enumeration of number types
 */
import { Float32BufferAttribute, Float64BufferAttribute, Int16BufferAttribute, Int32BufferAttribute, Int8BufferAttribute, Uint16BufferAttribute, Uint32BufferAttribute, Uint8BufferAttribute, } from "three";
/**
 * Returns the size in bytes the NumType variant describes
 * @param numType
 */
export function numByteSize(numType) {
    switch (numType) {
        case 9 /* NumType.F64 */:
        case 7 /* NumType.I64 */:
        case 3 /* NumType.U64 */: {
            return 8;
        }
        case 8 /* NumType.F32 */:
        case 6 /* NumType.I32 */:
        case 2 /* NumType.U32 */: {
            return 4;
        }
        case 4 /* NumType.I8 */:
        case 0 /* NumType.U8 */: {
            return 1;
        }
        case 5 /* NumType.I16 */:
        case 1 /* NumType.U16 */: {
            return 2;
        }
        default: {
            throw new Error("Unknown data type");
        }
    }
}
/**
 * Constructs a BufferAttribute from the provided buffer and the attribute's declared options
 * @param data The buffer containing the raw data
 * @param componentType
 * @param numComponents
 * @param normalized
 */
export function createAttributeBufferFor(data, componentType, numComponents, normalized) {
    switch (componentType) {
        case 3 /* NumType.U64 */:
            throw new Error("Unsupported BufferAttributeType U64");
        case 7 /* NumType.I64 */:
            throw new Error("Unsupported BufferAttributeType I64");
        case 0 /* NumType.U8 */:
            return new Uint8BufferAttribute(data, numComponents, normalized);
        case 1 /* NumType.U16 */:
            return new Uint16BufferAttribute(data, numComponents, normalized);
        case 2 /* NumType.U32 */:
            return new Uint32BufferAttribute(data, numComponents, normalized);
        case 4 /* NumType.I8 */:
            return new Int8BufferAttribute(data, numComponents, normalized);
        case 5 /* NumType.I16 */:
            return new Int16BufferAttribute(data, numComponents, normalized);
        case 6 /* NumType.I32 */:
            return new Int32BufferAttribute(data, numComponents, normalized);
        case 8 /* NumType.F32 */:
            return new Float32BufferAttribute(data, numComponents, normalized);
        case 9 /* NumType.F64 */:
            return new Float64BufferAttribute(data, numComponents, normalized);
    }
}
/**
 * Handles constructing the appropriate TypedArray type for the given num type
 * @param numType
 * @param buffer
 * @param byteOffset
 * @param length
 * @private
 */
export function constructBufferForNumType(numType, buffer, byteOffset, length) {
    switch (numType) {
        case 3 /* NumType.U64 */:
            throw new Error("Unsupported TypedArray U64");
        case 7 /* NumType.I64 */:
            throw new Error("Unsupported TypedArray I64");
        case 0 /* NumType.U8 */:
            return new Uint8Array(buffer, byteOffset, length);
        case 1 /* NumType.U16 */:
            return new Uint16Array(buffer, byteOffset, length);
        case 2 /* NumType.U32 */:
            return new Uint32Array(buffer, byteOffset, length);
        case 4 /* NumType.I8 */:
            return new Int8Array(buffer, byteOffset, length);
        case 5 /* NumType.I16 */:
            return new Int16Array(buffer, byteOffset, length);
        case 6 /* NumType.I32 */:
            return new Int32Array(buffer, byteOffset, length);
        case 8 /* NumType.F32 */:
            return new Float32Array(buffer, byteOffset, length);
        case 9 /* NumType.F64 */:
            return new Float64Array(buffer, byteOffset, length);
    }
}
